/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { ActionableNotification as CarbonToastNotification } from '@carbon/react';
import styled from 'styled-components';

export const transitionDuration = 350;
const offset = 352;

export const ToastNotification = styled(CarbonToastNotification)`
  position: relative;
  right: -${offset}px;
  z-index: var(--z-notification);

  // ActionableNotification is smaller than a Toast Notification, but we want to keep the same width
  min-width: 352px;

  transition:
    transform ${transitionDuration}ms ease-in-out,
    opacity ${transitionDuration / 2}ms ease-in-out;

  opacity: 0;

  &.entered {
    transform: translateX(-100%);
    opacity: 1;
  }

  &.exiting,
  &.exited {
    transform: translateX(100%);
    opacity: 0;
  }
`;
